module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marquee",
    attrs: {
      "id": "marquee"
    }
  }, [(_vm.language === "nl") ? _c('span', [_vm._v(_vm._s(_vm.quoteStringNL))]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('span', [_vm._v(_vm._s(_vm.quoteStringEN))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2da69799!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsMarquee.vue
// module id = 215
// module chunks = 2